webpackJsonp([247222586976726],{

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  padding-top: 110px;\n  padding-bottom: 40px;\n"], ["\n  padding-top: 110px;\n  padding-bottom: 40px;\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var package_comparison_header_1 = __webpack_require__(341);
	var package_comparison_expandable_element_1 = __webpack_require__(340);
	var styled_components_1 = __webpack_require__(2);
	
	var PackageComparisonBlock = function (_React$Component) {
	    _inherits(PackageComparisonBlock, _React$Component);
	
	    function PackageComparisonBlock() {
	        _classCallCheck(this, PackageComparisonBlock);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    PackageComparisonBlock.prototype.render = function render() {
	        return React.createElement("div", { className: "materialize-theme-styles" }, React.createElement(PackageComparisonBlockWrapper, null, React.createElement("div", { className: "container" }, React.createElement("div", { className: "row" }, React.createElement("div", { className: "col-xs-12" }, React.createElement("div", { className: "panel-group feature-accordion brand-accordion icon angle-icon", id: "basic" }, React.createElement(package_comparison_header_1.default, null), React.createElement(package_comparison_expandable_element_1.default, { appModuleName: "Moduł Fakturowy", appModuleElements: [{
	                elementName: "Faktury sprzedaży",
	                elementIsFree: true
	            }, {
	                elementName: "Faktury pro forma",
	                elementIsFree: true
	            }, {
	                elementName: "Własne logo na fakturze",
	                elementIsFree: true
	            }, {
	                elementName: "Wiele schematów numeracji faktur",
	                elementIsFree: true
	            }, {
	                elementName: "Własna numeracja faktur",
	                elementIsFree: true
	            }, {
	                elementName: "Wysyłanie faktur e-mailem",
	                elementIsFree: true
	            }, {
	                elementName: "Eksportowanie faktur",
	                elementIsFree: true
	            }, {
	                elementName: "Zapisywanie produktów",
	                elementIsFree: true
	            }, {
	                elementName: "Zbiorcze drukowanie faktur",
	                elementIsFree: true
	            }, {
	                elementName: "Integracja z GUS",
	                elementIsFree: true
	            }, {
	                elementName: "Wiele rachunków bankowych",
	                elementIsFree: true
	            }] }), React.createElement(package_comparison_expandable_element_1.default, { appModuleName: "Moduł CRM", appModuleElements: [{
	                elementName: "Katalog kontrahentów",
	                elementIsFree: true
	            }, {
	                elementName: "Import kontrahentów z GUS",
	                elementIsFree: true
	            }, {
	                elementName: "Zaawansowane ustawienia kontrahentów",
	                elementIsFree: true
	            }] }), React.createElement(package_comparison_expandable_element_1.default, { appModuleName: "Moduł Księgowość", appModuleElements: [{
	                elementName: "Polityka rachunkowości",
	                elementIsFree: false
	            }, {
	                elementName: "Plan kont",
	                elementIsFree: false
	            }, {
	                elementName: "Dziennik",
	                elementIsFree: false
	            }, {
	                elementName: "Księga główna",
	                elementIsFree: false
	            }, {
	                elementName: "Księga pomocnicza",
	                elementIsFree: false
	            }, {
	                elementName: "Zestaw. obr. i sald księgi głównej",
	                elementIsFree: false
	            }, {
	                elementName: "Zestaw. obr. i sald księgi pomocniczej",
	                elementIsFree: false
	            }, {
	                elementName: "Schematy księgowania przychodów",
	                elementIsFree: false
	            }, {
	                elementName: "Schematy księgowania kosztów",
	                elementIsFree: false
	            }, {
	                elementName: "Deklaracje VAT-7 i VAT-7K",
	                elementIsFree: false
	            }, {
	                elementName: "Rejestry VAT sprzedaży",
	                elementIsFree: false
	            }, {
	                elementName: "Rejestry VAT zakupu",
	                elementIsFree: false
	            }, {
	                elementName: "JPK_VAT",
	                elementIsFree: false
	            }, {
	                elementName: "JPK_KR",
	                elementIsFree: false
	            }, {
	                elementName: "JPK_FA",
	                elementIsFree: false
	            }, {
	                elementName: "Potwierdzenia sald kontrahentów",
	                elementIsFree: false
	            }, {
	                elementName: "Automatyczne rozliczenie WNT",
	                elementIsFree: false
	            }, {
	                elementName: "Automatyczne rozliczenie WDT",
	                elementIsFree: false
	            }, {
	                elementName: "Metoda kasowa VAT",
	                elementIsFree: false
	            }, {
	                elementName: "Księgowość podmiotów zwolnionych z VAT",
	                elementIsFree: false
	            }, {
	                elementName: "Zaliczki CIT",
	                elementIsFree: false
	            }, {
	                elementName: "Deklaracje CIT",
	                elementIsFree: false
	            }, {
	                elementName: "Sprawozdania finansowe",
	                elementIsFree: false
	            }, {
	                elementName: "Uchwały do sprawozdania finansowego",
	                elementIsFree: false
	            }, {
	                elementName: "Kalendarz z przypomnieniami",
	                elementIsFree: false
	            }] }), React.createElement(package_comparison_expandable_element_1.default, { appModuleName: "Moduł Kadrowy", appModuleElements: [{
	                elementName: "Rejestr pracowników",
	                elementIsFree: false
	            }, {
	                elementName: "Rozliczanie umów o pracę",
	                elementIsFree: false
	            }, {
	                elementName: "Rozliczanie umów zlecenia",
	                elementIsFree: false
	            }, {
	                elementName: "Rozliczanie umów o dzieło",
	                elementIsFree: false
	            }, {
	                elementName: "Rozliczanie aktów powołania",
	                elementIsFree: false
	            }, {
	                elementName: "Rozliczania ryczałtowe",
	                elementIsFree: false
	            }, {
	                elementName: "Listy płac",
	                elementIsFree: false
	            }, {
	                elementName: "Deklaracja PIT-11",
	                elementIsFree: false
	            }, {
	                elementName: "Deklaracja PIT-4R",
	                elementIsFree: false
	            }, {
	                elementName: "Deklaracja ZUS-RCA",
	                elementIsFree: false
	            }, {
	                elementName: "Deklaracja ZUS-DRA",
	                elementIsFree: false
	            }, {
	                elementName: "Deklaracja ZUS-ZUS",
	                elementIsFree: false
	            }, {
	                elementName: "Deklaracja ZUS-ZPA",
	                elementIsFree: false
	            }] }), React.createElement(package_comparison_expandable_element_1.default, { appModuleName: "Analizy finansowe", appModuleElements: [{
	                elementName: "Wykresy przychodów i kosztów",
	                elementIsFree: false
	            }] }), React.createElement(package_comparison_expandable_element_1.default, { appModuleName: "Bezpieczeństwo danych", appModuleElements: [{
	                elementName: "Aktualizacje aplikacji",
	                elementIsFree: true
	            }, {
	                elementName: "Kopie zapasowe baz danych",
	                elementIsFree: true
	            }, {
	                elementName: "Zabezpieczona transmisja danych",
	                elementIsFree: true
	            }] }), React.createElement(package_comparison_expandable_element_1.default, { appModuleName: "Pozostałe funkcje", appModuleElements: [{
	                elementName: "Księgowy",
	                elementIsFree: false
	            }, {
	                elementName: "Wsparcie techniczne",
	                elementIsFree: true
	            }, {
	                elementName: "Konta użytkowników",
	                elementIsFree: true
	            }, {
	                elementName: "Nadawanie przywilejów nowym użytkownikom",
	                elementIsFree: true
	            }, {
	                elementName: "Wiele firm jednego użytkownika",
	                elementIsFree: true
	            }] })))))));
	    };
	
	    return PackageComparisonBlock;
	}(React.Component);
	/** STYLES */
	
	
	var PackageComparisonBlockWrapper = styled_components_1.default.section(_templateObject);
	exports.default = PackageComparisonBlock;

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  height: 55px;\n  padding-right: 2px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  height: 55px;\n  padding-right: 2px;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  flex-basis: 40%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  color: #4d4d4d;\n"], ["\n  flex-basis: 40%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  color: #4d4d4d;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  flex-basis: 30%;\n  max-width: 300px;\n  box-shadow: 0 9px 0px 0px #fff, 0 -9px 0px 0px #fff, 12px 0 22px -4px rgba(0, 0, 0, 0.12), -12px 0 22px -4px rgba(0, 0, 0, 0.12);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  i.fa.fa-check {\n    color: green;\n  }\n  i.fa.fa-times {\n    color: red;\n  }\n"], ["\n  flex-basis: 30%;\n  max-width: 300px;\n  box-shadow: 0 9px 0px 0px #fff, 0 -9px 0px 0px #fff, 12px 0 22px -4px rgba(0, 0, 0, 0.12), -12px 0 22px -4px rgba(0, 0, 0, 0.12);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  i.fa.fa-check {\n    color: green;\n  }\n  i.fa.fa-times {\n    color: red;\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  padding-right: 2px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  padding-right: 2px;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  flex-basis: 40%;\n"], ["\n  flex-basis: 40%;\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  flex-basis: 30%;\n  max-width: 300px;\n  // box-shadow: 0 4px 2px 2px rgba(0, 0, 0, 0.12);\n  height: 1px;\n  border-bottom: 3px solid rgba(0, 0, 0, 0.12);\n"], ["\n  flex-basis: 30%;\n  max-width: 300px;\n  // box-shadow: 0 4px 2px 2px rgba(0, 0, 0, 0.12);\n  height: 1px;\n  border-bottom: 3px solid rgba(0, 0, 0, 0.12);\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose(["\n  h3 {\n    line-height: 1.1rem;  \n  }\n"], ["\n  h3 {\n    line-height: 1.1rem;  \n  }\n"]);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var styled_components_1 = __webpack_require__(2);
	var PackageComparisonExpandableElementRow = function PackageComparisonExpandableElementRow(props) {
	  var elementName = props.elementName,
	      elementIsFree = props.elementIsFree;
	
	  return React.createElement(PackageComparisonExpandableElementRowWrapper, null, React.createElement(FeatureNameWrapper, null, elementName), React.createElement(FeatureIconWrapper, null, React.createElement("i", { className: elementIsFree ? "fa fa-check fa-lg" : "fa fa-times fa-lg" })), React.createElement(FeatureIconWrapper, null, React.createElement("i", { className: "fa fa-check fa-lg" })));
	};
	/** STYLES => PackageComparisonExpandableElementRow */
	var PackageComparisonExpandableElementRowWrapper = styled_components_1.default.div(_templateObject);
	var FeatureNameWrapper = styled_components_1.default.div(_templateObject2);
	var FeatureIconWrapper = styled_components_1.default.div(_templateObject3);
	var PackageComparisonExpandableElementLastRow = function PackageComparisonExpandableElementLastRow(props) {
	  return React.createElement(PackageComparisonExpandableElementLastRowWrapper, null, React.createElement(FeatureNameLastRowWrapper, null), React.createElement(FeatureIconLastRowWrapper, null), React.createElement(FeatureIconLastRowWrapper, null));
	};
	/** STYLES => PackageComparisonExpandableElementLastRow */
	var PackageComparisonExpandableElementLastRowWrapper = styled_components_1.default.div(_templateObject4);
	var FeatureNameLastRowWrapper = styled_components_1.default.div(_templateObject5);
	var FeatureIconLastRowWrapper = styled_components_1.default.div(_templateObject6);
	
	var PackageComparisonExpandableElement = function (_React$Component) {
	  _inherits(PackageComparisonExpandableElement, _React$Component);
	
	  function PackageComparisonExpandableElement(props) {
	    _classCallCheck(this, PackageComparisonExpandableElement);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      elementIsOpen: false
	    };
	    _this.toggleElement = _this.toggleElement.bind(_this);
	    return _this;
	  }
	
	  PackageComparisonExpandableElement.prototype.toggleElement = function toggleElement() {
	    var elementIsOpen = this.state.elementIsOpen;
	
	    this.setState({ elementIsOpen: !elementIsOpen });
	  };
	
	  PackageComparisonExpandableElement.prototype.render = function render() {
	    var _props = this.props,
	        appModuleName = _props.appModuleName,
	        appModuleElements = _props.appModuleElements;
	    var elementIsOpen = this.state.elementIsOpen;
	
	    return React.createElement(PackageComparisonExpandableElementWrapper, { className: "panel panel-default", onClick: this.toggleElement }, React.createElement("div", { className: "panel-heading" }, React.createElement("h3", { className: "panel-title" }, React.createElement("a", { className: elementIsOpen ? '' : 'collapsed', "aria-expanded": elementIsOpen }, appModuleName))), React.createElement("div", { className: elementIsOpen ? 'panel-collapse collapse in' : 'panel-collapse collapse' }, React.createElement("div", null, appModuleElements.map(function (element, index) {
	      return React.createElement(PackageComparisonExpandableElementRow, _extends({ key: index }, element));
	    })), React.createElement(PackageComparisonExpandableElementLastRow, null)));
	  };
	
	  return PackageComparisonExpandableElement;
	}(React.Component);
	/** STYLES */
	
	
	var PackageComparisonExpandableElementWrapper = styled_components_1.default.div(_templateObject7);
	exports.default = PackageComparisonExpandableElement;

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  flex-basis: 30%;\n  max-width: 300px;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  padding-top: 30px;\n  padding-bottom: 10px;\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);\n  p {\n    margin: 0;\n    text-align: center;\n    color: #202020;\n    font-weight: bold;\n    font-size: 20px;\n    text-transform: uppercase;\n  }\n  a {\n    font-size: 12px !important;\n    font-weight: bold;\n  }\n"], ["\n  flex-basis: 30%;\n  max-width: 300px;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  padding-top: 30px;\n  padding-bottom: 10px;\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);\n  p {\n    margin: 0;\n    text-align: center;\n    color: #202020;\n    font-weight: bold;\n    font-size: 20px;\n    text-transform: uppercase;\n  }\n  a {\n    font-size: 12px !important;\n    font-weight: bold;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  padding-right: 2px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  padding-right: 2px;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  flex-basis: 40%;\n"], ["\n  flex-basis: 40%;\n"]);
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var staticUrls = __webpack_require__(17);
	var styled_components_1 = __webpack_require__(2);
	var PackageComparisonHeaderElement = function PackageComparisonHeaderElement(props) {
	  var packageName = props.packageName,
	      buttonColor = props.buttonColor,
	      buttonLinkTo = props.buttonLinkTo;
	
	  return React.createElement(PackageComparisonHeaderElementWrapper, null, React.createElement("p", null, packageName), React.createElement("div", { className: "text-center mt-30" }, React.createElement("a", { href: buttonLinkTo, target: "_blank", className: "btn btn-md waves-effect waves-light " + buttonColor }, "Wypr\xF3buj za darmo")));
	};
	/** STYLES => PackageComparisonHeaderElement */
	var PackageComparisonHeaderElementWrapper = styled_components_1.default.div(_templateObject);
	var PackageComparisonHeader = function PackageComparisonHeader(props) {
	  return React.createElement(PackageComparisonWrapper, null, React.createElement(PackageComparisonHeaderElementPositioner, null), React.createElement(PackageComparisonHeaderElement, { packageName: "Pakiet darmowy", buttonColor: "", buttonLinkTo: staticUrls.FAKTUROMANIA_REGISTRATION_PAGE_URL }), React.createElement(PackageComparisonHeaderElement, { packageName: "Pakiet premium", buttonColor: "", buttonLinkTo: staticUrls.FAKTUROMANIA_REGISTRATION_PAGE_URL }));
	};
	/** STYLES => PackageComparisonHeader */
	var PackageComparisonWrapper = styled_components_1.default.div(_templateObject2);
	var PackageComparisonHeaderElementPositioner = styled_components_1.default.div(_templateObject3);
	exports.default = PackageComparisonHeader;

/***/ }),

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var react_helmet_1 = __webpack_require__(23);
	var breadcrumbs_block_1 = __webpack_require__(42);
	var package_comparison_block_1 = __webpack_require__(339);
	var types_1 = __webpack_require__(14);
	var helmetData = __webpack_require__(21);
	var cacheBustingService = __webpack_require__(26);
	
	var PorownaniePakietowPage = function (_React$Component) {
	    _inherits(PorownaniePakietowPage, _React$Component);
	
	    function PorownaniePakietowPage() {
	        _classCallCheck(this, PorownaniePakietowPage);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    PorownaniePakietowPage.prototype.componentDidMount = function componentDidMount() {
	        cacheBustingService.handleCacheBusting(caches);
	    };
	
	    PorownaniePakietowPage.prototype.render = function render() {
	        return React.createElement("div", null, React.createElement(react_helmet_1.Helmet, _extends({}, helmetData.prepareHelmetData(types_1.PageType.PorownaniePakietowPage))), React.createElement(breadcrumbs_block_1.default, { breadcrumbsElement: {
	                elementName: "PORÓWNANIE PAKIETOW",
	                elementDescription: ""
	            } }), React.createElement(package_comparison_block_1.default, null));
	    };
	
	    return PorownaniePakietowPage;
	}(React.Component);
	
	exports.default = PorownaniePakietowPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-porownanie-pakietow-tsx-76d4d18ef774f38052fb.js